module.exports = __webpack_public_path__ + "static/services_func-b3a78245010e48708b7fa27da721dac4.jpg";